import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { api } from '@/lib/api';
import { resolveImageUrl } from '@/lib/resolveImageUrl';

export { resolveImageUrl };

export const FEATURED_SLOTS = {
    hero_home: 'Home — Hero principale',
    hero_atelier: 'Atelier — Hero',
    hero_negozio: 'Atelier — Sezione negozio',
    hero_matrimoni: 'Matrimoni — Hero',
    hero_workshop: 'Workshop — Hero',
    hero_giardini: 'Giardini — Hero',
    home_card_fiori: 'Home — Card "Atelier"',
    home_card_matrimoni: 'Home — Card "Matrimoni"',
    home_card_workshop: 'Home — Card "Workshop"',
    home_card_giardini: 'Home — Card "Giardini"',
};

const FeaturedImagesContext = createContext({
    map: {},
    loading: true,
    reload: () => { },
});

export const FeaturedImagesProvider = ({ children }) => {
    const [map, setMap] = useState({});
    const [loading, setLoading] = useState(true);

    const load = useCallback(async () => {
        try {
            const res = await api.get('/featured');
            const next = {};
            (res.data || []).forEach((row) => { next[row.slot] = row; });
            setMap(next);
        } catch {
            setMap({});
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => { load(); }, [load]);

    const value = useMemo(() => ({ map, loading, reload: load }), [map, loading, load]);

    return (
        <FeaturedImagesContext.Provider value={value}>
            {children}
        </FeaturedImagesContext.Provider>
    );
};

export const useFeaturedImages = () => useContext(FeaturedImagesContext);

export const useFeaturedImage = (slot) => {
    const { map, loading } = useContext(FeaturedImagesContext);
    const row = map[slot];
    return {
        loading,
        slot,
        hasImage: !!row?.image_url,
        imageUrl: row?.image_url ? resolveImageUrl(row.image_url) : null,
        title: row?.title || null,
        galleryItemId: row?.gallery_item_id || null,
    };
};
